import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "burger-menu cell shrink",
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('toggle')))
  }, [
    _createElementVNode("i", {
      class: _normalizeClass(["bi", _ctx.isOpen ? 'bi-x-lg' : 'bi-list'])
    }, null, 2)
  ]))
}